module.exports = __webpack_public_path__ + "img/power-pass.08baef6.svg";


//////////////////
// WEBPACK FOOTER
// ./static/svg/power-pass.svg
// module id = Dvxn
// module chunks = 1